import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FOLLOWERS').plugin(axiosPlugin, {template: "array"});

let fetchUserFollowersAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state) => {
    let newState = {...state};
    newState.total++;
    return newState;
});

redux.reducerForType('DELETE', (state) => {
    let newState = {...state};
    newState.total--;
    if(newState.total < 0){
        newState.total = 0;
    }
    return newState;
});

export const fetchUserFollowers = (userId, query = {}) => fetchUserFollowersAction(`/users/${userId}/followers?${queryString.stringify(query)}`);
export const resetUserFollowers = () => redux.actions.reset();

export const userFollowers = redux.reducer();